import { styled } from '@mui/system'

export const AppearanceTitle = styled('div')`
    margin-bottom: 24px;
`
